import React from 'react';
import styled, { keyframes } from 'styled-components';

//TODO: fix notification centering issue
const fadeInOut = keyframes`
  0% { opacity: 0; transform: translateY(-20px); }
  10% { opacity: 1; transform: translateY(0); }
  90% { opacity: 1; transform: translateY(0); }
  100% { opacity: 0; transform: translateY(-20px); }
`;

interface NotificationProps {
    isSuccess: boolean;
}

const NotificationContainer = styled.div<NotificationProps>`
  position: fixed;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
  background-color: ${({ isSuccess }) => (isSuccess ? '#6aaa64' : '#b22222')};
  color: #ffffff;
  padding: 16px 24px;
  border-radius: 8px;
  z-index: 1000;
  animation: ${fadeInOut} 3s ease forwards;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  font-size: 1rem;
`;

interface Props {
    message: string;
    isSuccess: boolean;
}

const Notification: React.FC<Props> = ({ message, isSuccess }) => {
    return <NotificationContainer isSuccess={isSuccess}>{message}</NotificationContainer>;
};

export default Notification;
